import React, { useCallback } from "react";
import { Card, Grid, Container, TextField } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";

import Autocomplete from "@material-ui/lab/Autocomplete";

const toId = (value) =>
  Number(typeof value === "object" && value != null ? value.id : value);

const MultiSelect = ({ field, label, data, value, onChange }) => {
  const filterChange = useCallback(
    (e, selected) => {
      onChange(selected?.map((item) => toId(item)).filter(Boolean));
    },
    [onChange]
  );

  const findOption = (item) =>
    (data || []).find((option) => Number(option.id) === toId(item));

  return (
    <Card className="shadow-xxl my-3 py-3">
      <Grid>
        <Container>
          <Autocomplete
            multiple
            getOptionSelected={(option, selected) =>
              Number(option.id) === toId(selected)
            }
            options={data || []}
            value={value || []}
            getOptionLabel={(option) => {
              const row = typeof option === "object" ? option : findOption(option);
              return row?.[field] || "";
            }}
            onChange={filterChange}
            renderTags={(selected, getTagProps) =>
              selected?.map((item, index) => {
                const row = findOption(item);
                return (
                  <Chip
                    key={toId(item) || index}
                    label={row?.[field] || ""}
                    {...getTagProps({ index })}
                  />
                );
              })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                variant="outlined"
                placeholder={label}
                fullWidth
              />
            )}
          />
        </Container>
      </Grid>
    </Card>
  );
};

export default MultiSelect;
